import React from "react";
import ReactDOM from "react-dom";

//function contente tutta quanta l'applicazione
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
